import { doc, getDoc, serverTimestamp, setDoc } from 'firebase/firestore'
import { firebaseDb } from './init'
import {
  IOcrCacheMarkSchemeBase,
  IOcrCacheMarkSchemePage,
  IOcrCacheMarkSchemePageBase,
  IOcrCacheMarkSchemePageRaw,
  IOcrCacheMarkSchemeRaw,
} from '../types/firebase/ocr-cache-ms'

export const OCR_CACHE_MARK_SCHEMES_COLLECTION = 'ocrCacheMarkSchemes'
const PAGES_SUBCOLLECTION = 'pages'

/**
 * Gets the root Mark Scheme cache document.
 */
export async function getMarkSchemeCacheDoc(
  id: string,
): Promise<IOcrCacheMarkSchemeRaw | null> {
  const docRef = doc(firebaseDb, OCR_CACHE_MARK_SCHEMES_COLLECTION, id)
  const docSnap = await getDoc(docRef)

  if (docSnap.exists()) {
    return docSnap.data() as IOcrCacheMarkSchemeRaw
  }
  return null
}

/**
 * Creates the root Mark Scheme cache document if it doesn't exist.
 */
export async function createMarkSchemeCacheDoc(
  id: string,
  data: IOcrCacheMarkSchemeBase,
): Promise<void> {
  const docRef = doc(firebaseDb, OCR_CACHE_MARK_SCHEMES_COLLECTION, id)
  await setDoc(docRef, {
    ...data,
    createdAt: serverTimestamp(),
    updatedAt: serverTimestamp(),
  })
}

/**
 * Gets cached OCR result for a specific page of a Mark Scheme.
 */
export async function getCachedMarkSchemePage(
  paperId: string,
  pageNumber: number,
): Promise<IOcrCacheMarkSchemePage | null> {
  const pageDocId = `page_${pageNumber}`
  const docRef = doc(
    firebaseDb,
    OCR_CACHE_MARK_SCHEMES_COLLECTION,
    paperId,
    PAGES_SUBCOLLECTION,
    pageDocId,
  )
  const docSnap = await getDoc(docRef)

  if (docSnap.exists()) {
    return { id: docSnap.id, ...(docSnap.data() as IOcrCacheMarkSchemePageRaw) }
  }
  return null
}

/**
 * Saves OCR result for a specific page of a Mark Scheme.
 */
export async function saveMarkSchemePage(
  paperId: string,
  dto: IOcrCacheMarkSchemePageBase,
): Promise<void> {
  const pageDocId = `page_${dto.pageNumber}`
  const docRef = doc(
    firebaseDb,
    OCR_CACHE_MARK_SCHEMES_COLLECTION,
    paperId,
    PAGES_SUBCOLLECTION,
    pageDocId,
  )
  await setDoc(docRef, {
    ...dto,
    createdAt: serverTimestamp(),
    updatedAt: serverTimestamp(),
  })
}
